import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const RenameModal = ({ isOpen, onClose, item, itemType, onRename }) => {
        const [newName, setNewName] = useState('');

        useEffect(() => {
                if (item) {
                        setNewName(item.name);
                }
        }, [item]);

        const handleRename = () => {
                onRename(item.id, newName);
        };

        if (!item) {
                return null;
        }

        return (
                <Modal isOpen={isOpen} onClose={onClose}>
                        <form onSubmit={(e) => { e.preventDefault(); handleRename(); }}>
                                <h3 className="text-lg font-bold mb-4">Rename {itemType}</h3>
                                <div className="space-y-4">
                                        <div>
                                                <label htmlFor="item-name" className="block text-sm font-medium text-gray-700">
                                                        {itemType} Name
                                                </label>
                                                <input
                                                        type="text"
                                                        id="item-name"
                                                        data-testid="rename-input"
                                                        value={newName}
                                                        onChange={(e) => setNewName(e.target.value)}
                                                        className="p-2 border rounded-md w-full"
                                                />
                                        </div>
                                </div>
                                <div className="mt-6 flex justify-end space-x-4">
                                        <button
                                                type="button"
                                                onClick={onClose}
                                                data-testid="rename-cancel"
                                                className="inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand sm:text-sm"
                                        >
                                                Cancel
                                        </button>
                                        <button
                                                type="submit"
                                                data-testid="rename-submit"
                                                disabled={!newName.trim()}
                                                className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-brand text-base font-medium text-white hover:bg-brand/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand sm:text-sm disabled:bg-gray-300"
                                        >
                                                Rename
                                        </button>
                                </div>
                        </form>
                </Modal>
        );
};

export default RenameModal;
